import Ashley from '../assets/sac-headshots2026/ashley.webp';
import Bhavith from '../assets/sac-headshots2026/bhavith.webp';
import Budrudeen from '../assets/sac-headshots2026/budrudeen.webp';
import Car from '../assets/sac-headshots2026/car.webp';
import Carmen from '../assets/sac-headshots2026/carmen.webp';
import Christine from '../assets/sac-headshots2026/christine.webp';
import Crystal from '../assets/sac-headshots2026/crystal.webp';
import Daniel from '../assets/sac-headshots2026/daniel.webp';
import Eleni from '../assets/sac-headshots2026/eleni.webp';
import Emily from '../assets/sac-headshots2026/emily.webp';
import Emma from '../assets/sac-headshots2026/emma.webp';
import Eric from '../assets/sac-headshots2026/eric.webp';
import Farhaan2026 from '../assets/sac-headshots2026/farhaan.webp';
import Ida from '../assets/sac-headshots2026/ida.webp';
import IvyDu from '../assets/sac-headshots2026/ivy du.webp';
import Joel from '../assets/sac-headshots2026/joel.webp';
import Madison from '../assets/sac-headshots2026/madison.webp';
import Mahisa from '../assets/sac-headshots2026/mahisa.webp';
import Melanie from '../assets/sac-headshots2026/melanie.webp';
import Noel from '../assets/sac-headshots2026/noel.webp';
import Prem from '../assets/sac-headshots2026/prem.webp';
import Serena from '../assets/sac-headshots2026/serena_.webp';
import Shandy from '../assets/sac-headshots2026/shandy.webp';
import Sophie from '../assets/sac-headshots2026/sophie.webp';
import Steven from '../assets/sac-headshots2026/tang.webp';
import Tristin from '../assets/sac-headshots2026/tranny.webp';
import Zoe from '../assets/sac-headshots2026/zoe.webp';
import Raghav from '../assets/sac-headshots2026/raghav.webp'

import AlanL from '../assets/sac-headshots2025/alan.webp';
import EmilyD from '../assets/sac-headshots2025/emily.webp';
import StevenT from '../assets/sac-headshots2025/steven.webp';
import MelanieS from '../assets/sac-headshots2025/melanie.webp';
import MadelynY from '../assets/sac-headshots2025/madelyn.webp';
import BhadraT from '../assets/sac-headshots2025/bhadra.webp';
import MadisonCM from '../assets/sac-headshots2025/madison.webp';
import MahisaT from '../assets/sac-headshots2025/mahisa.webp';
import SamW from '../assets/sac-headshots2025/sam.webp';
import JennyC from '../assets/sac-headshots2025/jenny.webp';
import AnitaT from '../assets/sac-headshots2025/anita.webp';
import TristinT from '../assets/sac-headshots2025/tristin.webp';
import AndrewL from '../assets/sac-headshots2025/andrew.webp';
import IsabelleZ from '../assets/sac-headshots2025/isabelle.webp';
import MengluZ from '../assets/sac-headshots2025/menglu.webp';
import ShyS from '../assets/sac-headshots2025/shy.webp';
import SeyonS from '../assets/sac-headshots2025/seyon.webp';
import NoelH from '../assets/sac-headshots2025/noel.webp';
import EmmaX from '../assets/sac-headshots2025/emma.webp';
import EricC from '../assets/sac-headshots2025/ericc.webp';
import EricS from '../assets/sac-headshots2025/erics.webp';
import SophieD from '../assets/sac-headshots2025/sophie.webp';
import EleanorL from  '../assets/sac-headshots2025/eleanor.webp';
import HaiyaoW from  '../assets/sac-headshots2025/haiyao.webp';
import FarhaanF from  '../assets/sac-headshots2025/farhaan.webp';
import Virk from '../assets/sac-headshots2025/virk.webp'
import Birch from '../assets/sac-headshots2025/MrBirch.webp'


export const Executives25 = [
  {
    id: 1,
    img: EmilyD,
    name: 'Emily Dong',
    title: 'President',
    instagram: "https://www.instagram.com/emily.dddd/",
    email: "341085132@gapps.yrdsb.ca",
    caption: "hii milliken!! my name is emily, your 24-25 sac prez!! this is my third (and final) year on sac 😢 but i truly believe that it is going to be the best one yet 💯. i like buying overpriced matcha lattes 🍵, my overpriced cat miso 🐈‍⬛, and collecting overpriced jellycats 🧸. we have such an awesome + hard working team this year and i can't wait to begin this new era of student council!! as always, my dms are open for any questions (@emily.dddd) see u around knights 😛"
  },
  {
    id: 2,
    img: StevenT,
    name: 'Steven Tang',
    title: 'Vice-President',
    instagram: "https://www.instagram.com/steventang26/",
    email: "349903153@gapps.yrdsb.ca",
    caption: "Heyyyy! This is Steven Tang your VP! 🎉It's my 3rd year on SAC (feeling like an unc now 😎) but I'm here to make sure this year is 🔥. Got questions or ideas? Slide into my DMs @steventang26. See you guys around and let's make Milliken great again!"
  },
  {
    id: 3,
    img: MelanieS,
    name: 'Melanie Shen',
    title: 'Student Advisor',
    instagram: "https://www.instagram.com/_.mels.anie._/",
    email: "349300467@gapps.yrdsb.ca",
    caption: "HI MILLIKEN I'm Melanie and I'm thrilled to be on sac again as a student advisor this year😝 if im not panicking about school or grinding semi decor again i love yapping,; brain rot, doing nail art and scrolling on my phone😔If you have ANY questions and suggestions about SAC or just want to yap about life, feel free to dm @_.mels.anie._ 😋"
  },
  {
    id: 4,
    img: MadelynY,
    name: 'Madelyn Young',
    title: 'Student Advisor',
    instagram: "https://www.instagram.com/madelynyoungg/",
    email: "341119758@gapps.yrdsb.ca",
    caption: "heyyy team i'm madelyn and i'm one of the three awesome student advisors on sac! when i'm not planning awesome sac activities, i enjoy cooking and doomscrolling 🥰  reach me @madelynyoungg  😚😚"
  },
  {
    id: 5,
    img: BhadraT,
    name: 'Bhadra Thumpayil',
    title: 'Student Advisor',
    instagram: "https://www.instagram.com/bhadra.th/",
    email: "341058253@gapps.yrdsb.ca",
    caption: "hi knights my name is bhadra and i'm part of your amazing student advisor team this year! outside of school, i unfortunately don't do much, but i enjoy reading, finding stickers for my laptop or trying new sidequests. if you have any questions or ideas for sac (or model un) my insta is @bhadra.th. see you around!"
  },
];

export const Secretary25 = [
  {
    id: 6,
    img: AlanL,
    name: 'Alan Lin',
    title: 'Secretary',
    instagram: "https://www.instagram.com/alanctic/",
    email: "348610858@gapps.yrdsb.ca",
    caption: "What's up Knights 🔥, this is Alan, your one and only SAC secretary this year.  This is my first year on the council, and it has already taught me how to type 300WPM per minute 😵‍💫. Anyways,  I love to talk and network, so feel free to wave me in the halls or dm me at @alanctic. Let's make this year a total blast 😉"
  },
];

export const SocialAffairs25 = [
  {
    id: 7,
    img: MadisonCM,
    name: 'Madison C. Mitran',
    title: 'Internal Affairs',
    email: "348601295@gapps.yrdsb.ca",
    caption: "Hi all! I'm Madison - the internal social affairs coordinator for 2024-25. Questions about clubs or events? Make sure you reach out in school, or send me an email (348601295@gapps.yrdsb.ca) and I'll get back to you ASAP - that is, when I'm not in the pool or reading feminist literature... 💜"
  },
  {
    id: 8,
    img: MahisaT,
    name: 'Mahisa Thayananthan',
    title: 'External Affairs',
    instagram: "https://www.instagram.com/mahisathaya/",
    email: "348698739@gapps.yrdsb.ca",
    caption: "Hey KNIGHTS!! 📢💥😜 My name is Mahisa and I am one of your social affairs on sac! This is my first year on SAC and I hope to make it special just for everyone else! 🫶✨ If you ever want to just chat or have any questions feel free to dm me @mahisathaya. Some of my favourite things to do is yapping, music, and reading!"
  },
];

export const Treasurers25 = [
  {
    id: 9,
    img: SamW,
    name: 'Sam Wang',
    title: 'Treasurer',
    instagram: "https://www.instagram.com/sam.wwang/",
    email: "349896803@gapps.yrdsb.ca",
    caption: "Wasssup Milliken! I'm Sam, one of your treasurers for this year! 💰💰 It's my first year on SAC and I’m here to make sure we keep that 🍞 up for all the fun stuff this year! Feel free to message me anytime @sam.wwang! Let's get the funds flowing, and good times rolling  💸😎 "
  },
  {
    id: 10,
    img: JennyC,
    name: 'Jenny Cai',
    title: 'Treasurer',
    instagram: "https://www.instagram.com/just.fluffs/",
    email: "348894338@gapps.yrdsb.ca",
    caption: "Hey Knights! I'm Jenny, your other treasurer for this year! This is also my first year on SAC and I hope to make funds more accessible for student events and planning!"
  },
];

export const Publicity25 = [
  {
    id: 11,
    img: AnitaT,
    name: 'Anita Tran',
    title: 'Graphic Publicity',
    instagram: "https://www.instagram.com/anitatr4n/",
    email: "341115772@gapps.yrdsb.ca",
    caption: "Hi guys I really want a dog @anutlord @anitatr4n"
  },
  {
    id: 12,
    img: TristinT,
    name: 'Tristin Tran',
    title: 'Graphic Publicity',
    instagram: "https://www.instagram.com/s3leryy_/",
    email: "348858887@gapps.yrdsb.ca",
    caption: "What is UP my mighty knightys 🔥 Im tristin and I'll be one of your graphic pubs along with the GOAT anita tran #tranandtran4L 🙏 I am a first year saccie (along with my dayone's menglu and mahisa) and am so excited to work with this amazing team to make this year the BEST school year EVER 😳 Feel free to say hi if you see me in the hall, have a chat @s3leryy_ @trisownies or look at my PERFECT letterboxd @ rambeau 👍 "
  },
  {
    id: 13,
    img: AndrewL,
    name: 'Andrew Li',
    title: 'Visual Publicity',
    instagram: "https://www.instagram.com/just.andrew.li/",
    email: "348793829@gapps.yrdsb.ca",
    caption: "Hey knights! I'm andrew and i'll be one of your visual pubs this year. When i'm not staying long hours after school to meet banner deadlines, i love collecting smiskis 🎎 and rock climbing 🧗. say hi @just.andrew.li"
  },
  {
    id: 14,
    img: IsabelleZ,
    name: 'Isabelle Zhao',
    title: 'Visual Publicity',
    instagram: "https://www.instagram.com/iiiiisabelle_z/",
    email: "350801643@gapps.yrdsb.ca",
    caption: "hey knights I'm Isabelle and i am one of ur visual pubs this year‼️. This is my third year on sac. im really looking forward to graduation 😍😍😻😻❤️‍🔥"
  },
  {
    id: 15,
    img: MengluZ,
    name: 'Menglu Zhu',
    title: 'Visual Publicity',
    instagram: "https://www.instagram.com/mengluzhuu/",
    email: "349673046@gapps.yrdsb.ca",
    caption: "Hey Milliken, I’m Menglu and I’m one of your visual pubs this year. I’m super excited to be on SAC and work with this wonderful team to make this year the best one yet. If you ever see me around or have anything to talk about, feel free to say hi! :))"
  },
];

export const Reps25 = [
  {
    id: 16,
    img: ShyS,
    name: 'Shy Safi',
    title: 'Grade 12 Rep',
    email: "341152288@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/shyysafi/",
    caption: "heyyy milliken! my name is shy, this years grade 12 (unc) rep. as i approach my last year at milliken, i'll make sure to make it the most memorable yet! feel free to message me @shyysafi 😊"
  },
  {
    id: 17,
    img: SeyonS,
    name: 'Seyon Satheesh',
    title: 'Grade 11 Rep',
    email: "350788782@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/seyonsatheesh/",
    caption: "Hey Milliken — My name is Seyon Satheesh and I'm your Grade 11 Rep for this year. Feel free to contact me if you have any questions about SAC or our events."
  },
  {
    id: 18,
    img: NoelH,
    name: 'Noel Ho',
    title: 'Grade 10 Rep',
    email: "440001311@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/noelhohohoe/",
    caption: "Hey Knights‼️I'm Noel, this years grade 10 rep🤓 Though it's my first year on SAC, I'm sure we'll make it the BEST year ever. I like singing, drawing, and rotten mango podcasts. If you have any questions or need a yap buddy, hit me up on @noelhohoho on insta🥳🥳"
  },
  {
    id: 19,
    img: EmmaX,
    name: 'Emma Xu',
    title: 'Grade 9 Rep',
    email: "349309971@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/emma.10.xu/",
    caption: "Heyy milliken, I’m Emma! One of the grade 9 reps along with Farhaan! This year is my first of (hopefully) many years on sac, and I'm super excited to make your time at school a blast😋!! Fun facts about me: I swim and run, but I can’t play any other sports😒, I loveee yapping to everyone about anything😁, and my favourite food is strawberries 😍! If you see me in the halls, come and say hi or dm me @emma.10.xu!"
  },
  {
    id: 20,
    img: FarhaanF,
    name: 'Farhaan Ferdous',
    title: 'Grade 9 Rep',
    email: "440004317@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/farhaan.ff/",
    caption: "wassupp knights 🔥🔥🔥, im farhaan, one of the grade 9 reps for this year alongside emma!! this is my first year on sac and i’m here to make it as memorable as possible 😝! some info abt me: i love playing sports (esp badminton 🏸). i also LOVE yapping, so if u see me around, come dab me up, im sure ill be down to chat 🗣. im rlly excited to see how this year unfolds ‼️‼️ feel free to send me a dm anytime on insta (@farhaan.ff)"
  },
  {
    id: 21,
    img: HaiyaoW,
    name: 'Haiyao Wu',
    title: 'ESL Rep', 
    email: "440028321@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/_wltjd.914/",
    caption: "Heyyy knights! ✨ I'm Haiyao, your ESL Rep at Milliken Mills High School this year. I love drinking matcha Frapps (even though they are so overprized) 🍵, listening to music 🎶, and I dance sometimes,I can't wait to meet every one of you, and I'm always here to help with any questions you have, don’t be shy to DM! 📲😊@_wltjd.914"
  },
];

export const Tech25 = [
  {
    id: 22,
    img: EricC,
    name: 'Eric Chen',
    title: 'Tech Chair',
    email: "349146373@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/zxc.eric_/",
    caption: "hey milliken! im eric c, your tech chair for this year, and i heavily dislike replit🔥@zxc.eric_"
  },
  {
    id: 23,
    img: EleanorL,
    name: 'Eleanor Liu',
    title: 'Photo/Videographer',
    email: "348823162@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/ll.eleanor/",
    caption: "hi milliken! im eleanor, the sac photographer/videographer this year and i now have a profound hatred for ios cameras"
  },
  {
    id: 24,
    img: SophieD,
    name: 'Sophie Ding',
    title: 'A.V. Rep',
    email: "348592650@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/daweirddragon/",
    caption: "Hey Knights, I'm Sophie, and I'm in charge of audio/visual tech along with Eric S. That means you should COME SEE OUR SHOWS!!! 🔥🔥🔥 I'm always up for a good chat, so you can find me at @daweirddragon or sometimes in the music hallway. See you around!"
  },
  {
    id: 25,
    img: EricS,
    name: 'Eric Siu',
    title: 'A.V. Rep',
    email: "348965971@gapps.yrdsb.ca",
    instagram: "https://www.instagram.com/yentah__/",
    caption: "Hi milliken, I'm Eric.s, and I'm in charge of audio/visual tech along with Sophie. This is my last year on SAC. I love boba (the store at dension remembers my order) and studying advance functions yippie!! You can find me at @yentah__ or in the drama room if im on my spare."
  },
];

export const TeacherAdvisors25 = [
  {
      id: 23,
      img: Virk,
      name: 'Ms. Virk',
      title: 'Teacher Advisor',
      caption: ""
    },
    {
      id: 24,
      img: Birch,
      name: 'Mr. Birch',
      title: 'Teacher Advisor',
      caption: ""
    }
];

export const Executives26 = [
  {
    id: 1,
    img: Steven,
    name: "Steven Tang",
    title: "President",
    instagram: "https://www.instagram.com/steventang26/",
    email: "349903153@gapps.yrdsb.ca",
    caption:
      "Howdy🤠 It's Big Tang here and what an amazing year it's been so far! Let's keep showing the Milliken spirit loud and proud because we are THE BEST school in YRDSB with THE BEST student council. You have 7 months to prove me wrong ❤️❤️ Make sure to check out the SAC all-star roster after us because they're the real BIG DAWGS 🐶."
  },
  {
    id: 2,
    img: Tristin,
    name: "Tristin Tran",
    title: "Vice-President",
    instagram: "https://www.instagram.com/tristintr4n/",
    email: "348858887@gapps.yrdsb.ca",
    caption:
      "hey Knights! i'm Tristin, this year's SAC Vice President with Big Tang 😎. this is my second (and final 🙁) year on SAC, and i'm so excited to bring y'all the BEST year in milliken HISTORY. when im not working with this amazing team, you'll probably see me around with a camera, eating caf beef patties or missing my boy @anitatr4n 😔 if you ever see me, feel free to say hi! @tristintr4n for any questions or just a chat - T 🤏 🏁"
  },
  {
    id: 3,
    img: Madison,
    name: "Madison Chee Mitran",
    title: "Student Advisor",
    instagram: "",
    email: "348601295@gapps.yrdsb.ca",
    caption:
      "Hello! I'm Madison, one of your four student advisors, and I'm so excited to serve you all on SAC this year. My true passions in life are feminist literature (in a non-performative way, I swear 😊✊), dad jokes, and rhetorical analysis so if you want to have a conversation about any of those, find me in the hallways! I'm ready to SACrifice to make this the best year possible 🙂😁🎒🍚"
  },
  {
    id: 4,
    img: Melanie,
    name: "Melanie Shen",
    title: "Student Advisor",
    instagram: "https://www.instagram.com/_.mels.anie._/",
    email: "349300467@gapps.yrdsb.ca",
    caption:
      "Yoyoyo im Mels and im soso excited and sad this will be my third and final year on SAC😔 during semi you mightve seen me LIVE by the sac closet working on decor💀but i also love sleeping, eating and painting my nails😋If you have any questions about events, school or just wanna chat feel free to reach out @_.mels.anie._ 😛 lets make this year awesome🙈🙈"
  },
  {
    id: 5,
    img: Noel,
    name: "Noel Ho",
    title: "Student Advisor",
    instagram: "https://www.instagram.com/noelhohohoe/",
    email: "440001311@gapps.yrdsb.ca",
    caption:
      "Hey Knights! I'm Noel and I can't wait to student advise the heck out of you. Let's make this year the best year yet! 😎 Hit me up @noelhohohoe"
  },
  {
    id: 6,
    img: Sophie,
    name: "Sophie Ding",
    title: "Student Advisor",
    instagram: "https://www.instagram.com/daweirddragon/",
    email: "348592650@gapps.yrdsb.ca",
    caption:
      "What's up guys! I'm Sophie, your friendly neighbourhood not-Spiderman, but I hope I can still be helpful to you guys this year! Aside from studying until 1 am (hit me up for IB French tutoring), I enjoy writing convoluted stories and improvising popular songs on the piano. Find me at @daweirddragon on Instagram or Discord. See you around! 🫡"
  }
];

export const Secretary26 = [
  {
    id: 1,
    img: Car,
    name: "Kara Zhang",
    title: "Secretary",
    instagram: "https://www.instagram.com/carzooha/",
    email: "348612318@gapps.yrdsb.ca",
    caption:
      "BEEP BEEP! i'm kar, this year's SAC Secretary 😎 even though its my one and only year, I LOVE SAC AND ILL MAKE SURE YALL KNOW IT! when im not secretarying, i'm definitely chopping it up with my buds 🤏🤏 if you PERCHANCE 🤷‍♂️ wanna chat🚦@carzooha is the place to go! - K 🏁🤏"
  }
];

export const SocialAffairs26 = [
  {
    id: 1,
    img: Mahisa,
    name: "Mahisa Thayananthan",
    title: "External Social Affairs",
    instagram: "https://www.instagram.com/mahisathaya/",
    email: "348698739@gapps.yrdsb.ca",
    caption:
      "Hi Knights!!! Im Mahisa, your external social affairs on SAC this year! 😛This is my second year on being on the council and im so excited to bring back even more with my experience from last year. We'll make sure to cook the best scrumptious events you've ever seen! If you have any questions please don't hesitate to reach me at @mahisathaya!"
  },
  {
    id: 2,
    img: Shandy,
    name: "Shandy Chen",
    title: "Internal Social Affairs",
    instagram: "https://www.instagram.com/sychq_/",
    email: "349046127@gapps.yrdsb.ca",
    caption:
      "hi knights! i'm shandy, this year's SAC internal social affairs! this is my first year on SAC and i have already learned every feature on gmail. if you see me late to class, no you didn’t 😓(feel free to say hi).  @sychq_ if you have any questions or just wanna chat 😛"
  }
];

export const Treasurers26 = [
  {
    id: 1,
    img: Joel,
    name: "Joel Li",
    title: "Treasurer",
    instagram: "https://www.instagram.com/joel.li.2009/",
    email: "348819749@gapps.yrdsb.ca",
    caption:
      "Hello! I'm Joel, one of your treasurers for this school year. I love finance and accounting, so I can't wait to manage SAC's financial information! I also like playing Roblox, listening to music, and doing school side projects. My handle is @joel.li.2009 !"
  },
  {
    id: 2,
    img: Raghav,
    name: "Raghav Chawla",
    title: "Treasurer",
    instagram: "https://www.instagram.com/Raghavc872008/",
    email: "348592304@gapps.yrdsb.ca",
    caption:
      "whats up knights! im chawla and i love to play sports 🏀🏈 i am in love with the student activity council and am so excited to be managing our budget this year! 😊"
  }
];

export const Publicity26 = [
  {
    id: 1,
    img: Ashley,
    name: "Ashley Habid",
    title: "Graphic Publicity",
    instagram: "https://www.instagram.com/ashcaakees/",
    email: "348801424@gapps.yrdsb.ca",
    caption:
      "hey guys!! i'm ashley and i’m one of this year’s gpubs along with my boi emmur xuxu 😛😉 i can't wait to create designs for this year 👩‍💻 illustrator is my opp 😤 feel free to say hi or if you want to buy me beabadoobee merch @ashcaakees @ashllibee"
  },
  {
    id: 2,
    img: Emma,
    name: "Emma Xu",
    title: "Graphic Publicity",
    instagram: "https://www.instagram.com/emma.10.xu/",
    email: "349309971@gapps.yrdsb.ca",
    caption:
      "wassup knights i'm emma and i'm one of this year's gpubs along with ashillibee! i'm excited to spend the year on photoshop and supporting vpubs w/banners 🎨 hmu @emma.10.xu @3mmaa.c0mm if u wanna learn to be performative 😛"
  },
  {
    id: 3,
    img: Emily,
    name: "Emily Hou",
    title: "Visual Publicity",
    instagram: "https://www.instagram.com/fried.chikn14/",
    email: "350917746@gapps.yrdsb.ca",
    caption:
      "whats up guys! im emily and i'm one of your visual pubs this year 💪💪 i love drawing and eating food (specifically mcdonald's cookies 🍪) and i hate ants 🐜 feel free to say hi @fried.chikn14 and let's make 2025-2026 the best year yet!"
  },
  {
    id: 4,
    img: Ida,
    name: "Ida Wang",
    title: "Visual Publicity",
    instagram: "https://www.instagram.com/i.da_wang/",
    email: "348800046@gapps.yrdsb.ca",
    caption:
      "hi guys!! im ida and im part of this years awesome v-pub team! 🎨👨‍🎨 if im not skating or studying, youll probably see me on the floor (painting banners obviously) 🐒 feel free to say hi or dm me @i.da_wang 😋"
  },
  {
    id: 5,
    img: Zoe,
    name: "Zoe Sun",
    title: "Visual Publicity",
    instagram: "https://www.instagram.com/zzoe.sun/",
    email: "349171710@gapps.yrdsb.ca",
    caption:
      "Hey knights!! i cant wait to paint some more banners and bring some of the best visuals your way! 🫟 @zzoe.sun is my tag feel free to say hi"
  }
];

export const Reps26 = [
  {
    id: 1,
    img: Farhaan2026,
    name: "Farhaan Ferdous",
    title: "Grade 10 Representative",
    instagram: "https://www.instagram.com/farhaan.ff/",
    email: "440004317@gapps.yrdsb.ca",
    caption:
      "What is good knights 👋 I'm Farhaan, yall's Grade 10 rep. It's my second year on SAC as a grade rep, and I'm here to make it even better than the last. Hmu if you got any questions @farhaan.ff and keep an eye out for more reels and fun events 👀"
  },
  {
    id: 2,
    img: Bhavith,
    name: "Bhavith Gembali",
    title: "Grade 11 Representative",
    instagram: "https://www.instagram.com/bhavithgembali/",
    email: "350150819@gapps.yrdsb.ca",
    caption:
      "Wtsp knights, my name is Bhavith (or the other 1000 names I have😜) and I am your Grade 11 rep this year 🤓.  Its my first year, i love SAC and representing milliken's 11's. also i'm the biggest yapster you can find so if you find me in the halls be sure to say hi (rmb that i'm basically bound to forget your name 😭 the first few times :DD) 😎 or hmu at @bhavithgembali"
  },
  {
    id: 3,
    img: Budrudeen,
    name: "Budrudeen Chishti",
    title: "Grade 12 Representative",
    instagram: "https://www.instagram.com/bc_deen/",
    email: "348593344@gapps.yrdsb.ca",
    caption:
      "WAZZAAHH KNIGHTS!!! 🤘🏻🤙🏻. i'm budrudeen (or bud), and i'm your grade 12 rep this year. along with doing all the cool things grade reps do, my unwritten responsibility is to make senior year the most memorable and fire year of high school🔥. if you're a senior and have ideas of what i can do for our final year, feel free to hmu @bc_deen."
  },
  {
    id: 4,
    img: Prem,
    name: "Prem Kataria",
    title: "Grade 9 Representative",
    instagram: "https://www.instagram.com/premkataria/",
    email: "440072867@gapps.yrdsb.ca",
    caption:
      "Hey Knights its Prem! Im one of two very cool grade 9 reps 😎 . Ive only been here for less than a year and I LOVE Milliken 🫶! If you need help or have questions about future events or just wanna chat hmu on insta anytime 🥹✌️ : @premkataria"
  },
  {
    id: 5,
    img: Eleni,
    name: "Eleni Kyriakou",
    title: "Grade 9 Representative",
    instagram: "https://www.instagram.com/eleni.kyria07/",
    email: "349266650@gapps.yrdsb.ca",
    caption:
      "What's up Knights! Its Eleni, your other super cool Grade 9 rep 🔥😛. It's my first year on SAC (hopfully not my last 😛✌️) and I'm loving it! Getting to represent our crazy grade 9s is an honor (jk, you're all my GOATS)! Even after a few months Milliken already feels like my second home (thanks to you guys🫰). Feel free to hmu if you have any questions or if you just want to chat, I'm cronicly online 🤫 : @eleni.kyria07"
  },
  {
    id: 6,
    img: Serena,
    name: "Xinyan Cai (Serena)",
    title: "MLL Representative",
    instagram: "https://www.instagram.com/sere_nyaaa/",
    email: "440036593@gapps.yrdsb.ca",
    caption:
      "HEY Knights! This is Serena 😼, your MLL rep this year with Crystal 📚. It's my first year on SAC and I’m excited to make lasting memories with ALL of you 😎! I love ACGN, music, and traveling 🎧✈️. I’m bilingual (English / Mandarin) and super supportive, so feel free to hmu @sere_nyaaa if you need language help or just wanna chat 💚. Catch me in the halls and say hi 😜👋"
  },
  {
    id: 7,
    img: Crystal,
    name: "Yuhan Cheng (Crystal)",
    title: "MLL Representative",
    instagram: "https://www.instagram.com/_fyoohan/",
    email: "440036597@gapps.yrdsb.ca",
    caption:
      "Hiiiii Knight!! It’s Crystal 💎 aka your MLL rep this year with Serena 🙋🏻‍♀️😝 It’s my first year in SAC and I already LOVEEEE this EXCELLENT team sooo much (you’re all literally the best🫶🥹) I’m a huge BLACKPINK stan 💗🖤 and a total sweet-tooth 🍰💅. I speak English & Mandarin fluently, so if you ever hit a language barrier or just wanna chat, rant, or just need a buddy, my DMs are always open @_fyoohan ✨Can’t wait for an amazing SAC year with y’all 💖"
  }
];

export const Tech26 = [
  {
    id: 1,
    img: Eric,
    name: "Eric Chen",
    title: "Tech Chair",
    instagram: "https://www.instagram.com/zxc.eric_/",
    email: "349146373@gapps.yrdsb.ca",
    caption:
      "what's up knights 🔥 i'm eric and i do website stuff for sac 😁 if u have any questions about how i integrate claude and codex into my workflow or wanna chat, hmu @zxc.eric_"
  },
  {
    id: 2,
    img: IvyDu,
    name: "Ivy Du",
    title: "Videographer",
    instagram: "https://www.instagram.com/ivy.y.yy/",
    email: "348586017@gapps.yrdsb.ca",
    caption:
      "hi guys! you probably saw me with the big camera light at semi but i'm super excited to be this year's videographer 😁 get ready to be clipped ❤️"
  },
  {
    id: 3,
    img: Carmen,
    name: "Carmen Chen",
    title: "AV Representative",
    instagram: "https://www.instagram.com/_.y3ah._/",
    email: "348831124@gapps.yrdsb.ca",
    caption:
      "Hey guys! I'm Carmen and I'm this year's AV Rep 👋 I'm here to support events with tech and to help make this year a great year! If you ever wanna chat hit me up @._y3ah_.!!!♡"
  },
  {
    id: 4,
    img: Daniel,
    name: "Daniel Ou",
    title: "AV Representative",
    instagram: "https://www.instagram.com/deoyvon/",
    email: "348784273@gapps.yrdsb.ca",
    caption:
      "Hi everyone! I'm Daniel and I am also one of this year's AV Rep! It's my first year on SAC and I am here to help provide any events and shows with AV tech! Feel free to dm me @deoyvon! 😄"
  },
  {
    id: 5,
    img: Christine,
    name: "Christine Zheng",
    title: "AV Representative",
    instagram: "https://www.instagram.com/akswksseiwhwjw/",
    email: "440003261@gapps.yrdsb.ca",
    caption:
      "Hey Knights!! im christine and im one of your AV Reps this year 😛😛 im excited to be on the caf balcony and lets have a great year !! hit me up at @akswksseiwhwjw"
  }
];

export const TeacherAdvisors26 = [
  {
      id: 23,
      img: "https://images.unsplash.com/photo-1494791368093-85217fbbf8de?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8b2NlYW58ZW58MHwyfDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60",
      name: 'Mr. Huang',
      title: 'Teacher Advisor',
      caption: ""
    },
    {
      id: 24,
      img: Birch,
      name: 'Mr. Birch',
      title: 'Teacher Advisor',
      caption: ""
    }
];

const councilRoles = [
  'Executives',
  'Secretary',
  'SocialAffairs',
  'Treasurers',
  'Publicity',
  'Reps',
  'Tech',
  'TeacherAdvisors',
];

const emptyCouncilTemplate = councilRoles.reduce((acc, role) => {
  acc[role] = [];
  return acc;
}, {});

const createCouncilYear = (roleOverrides) => ({
  ...emptyCouncilTemplate,
  ...roleOverrides,
});

const council2024_2025 = createCouncilYear({
  Executives: Executives25,
  Secretary: Secretary25,
  SocialAffairs:SocialAffairs25,
  Treasurers: Treasurers25,
  Publicity: Publicity25,
  Reps: Reps25,
  Tech: Tech25,
  TeacherAdvisors: TeacherAdvisors25,
});

const council2025_2026 = createCouncilYear({
   Executives: Executives26,
  Secretary: Secretary26,
  SocialAffairs:SocialAffairs26,
  Treasurers: Treasurers26,
  Publicity: Publicity26,
  Reps: Reps26,
  Tech: Tech26,
  TeacherAdvisors: TeacherAdvisors26,
});

export const councilYears = {
  '2024-2025': council2024_2025,
  '2025-2026': council2025_2026,
};

export const councilYearOrder = ['2024-2025', '2025-2026'];
export const councilRoleOrder = councilRoles;
